import "./css/auth.css";
import logo from "../../assets/images/logo1.png";
import carouselImg1 from "../../assets/images/registerCarouselImg1.png";
import CustomSvg from "../svgs/CustomSvg";
import { useEffect, useState } from "react";
import { FiEye, FiEyeOff } from "react-icons/fi";
import { Formik, ErrorMessage } from "formik";
import { Carousel, Spinner } from "react-bootstrap";
import SuccessModal from "./auxiliary/SuccessModal";
import { useLocation, useNavigate } from "react-router-dom";
import { loginFunc } from "../apiRequests/requestApi";
import { useUser } from "../../utils/hooks";
import { formatDateString } from "../../utils";
import * as yup from "yup";
import { EMAIL_REGEX } from "../helpers/regex";
import ScrollTo from "../scroll/ScrollTo";
import CustomErrorMsg from "../errorMsg/CustomErrorMsg";
import socket from "../../socket"; // or wherever your socket instance is
import axios from "axios";
import helpers from "../../components/helpers/helpers";

const { apiUrl } = helpers;

const carouselItems = [
  {
    img: carouselImg1,
    caption:
      "Play classics like Scrabble, WHOT, Chess, and Snooker with friends and family while betting to win big.",
  },
];

export default function Login({ accountType }) {
  const navigate = useNavigate();
  const navigateTo = (path) => navigate(path);
  const location = useLocation();

  const from = location.state?.from?.pathname || "/";

  const goToForgotPassword = () => navigateTo("/forgot-password");
  const goToDashboard = () => navigate(from, { replace: true });
  const goToRegister = () => navigateTo("/choose-account-type");

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [apiReqs, setApiReqs] = useState({
    isLoading: false,
    data: null,
    errorMsg: null,
  });
  const [successModal, setSuccessModal] = useState({
    visible: false,
    onHide: null,
    size: "md",
  });

  // const themeClass = accountType === 'celebrity' ? 'login-bg-celebrity' : 'login-bg-regular';

  useEffect(() => {
    if (apiReqs.data && apiReqs.isLoading) {
      const { data } = apiReqs;

      submit({ requestBody: data });
    }
  }, [apiReqs]);

  const { setUserDetails } = useUser();

  const validationSchema = yup.object().shape({
    email: yup
      .string()
      .matches(EMAIL_REGEX, "Must be a valid email")
      .required("Email required"),
    password: yup.string().required("Password required"),
  });

  const submit = async ({ requestBody }) => {
    try {
      const { email, password } = requestBody;

      const response = await loginFunc(requestBody);

      const { tokens, user } = response.data;
      if (response.data.user) {
        const user = response.data.user;
        const accountType = user.isCelebrity ? "celebrity" : "regular";
        localStorage.setItem("accountType", accountType);
      }

      sessionStorage.setItem("token", JSON.stringify(tokens));
    

      // Check for pending FCM token and send it
      const pendingFCMToken = localStorage.getItem("pendingFCMToken");
      if (pendingFCMToken) {
        setTimeout(async () => {
          try {
            await axios.post(`${apiUrl}/user/fcm-token`, {
              fcmToken: pendingFCMToken,
            });
            localStorage.setItem("fcmToken", pendingFCMToken);
            localStorage.removeItem("pendingFCMToken");
          } catch (err) {
            // console.error("Error sending pending FCM token:", err);
          }
        }, 120000);
      }

      const result = {
        ...user,
        dob: formatDateString(user?.dob, "short"),
        bgClass: "bg-FD8D84",
        country: "Nigeria",
      };
      setUserDetails(result);
      // console.log("User details set:", result);

      openSuccessModal();

      setApiReqs({ isLoading: false, data: null, errorMsg: null });

      // navigate(from, { replace: true });

      socket.connect();
    } catch (error) {

      setApiReqs({
        isLoading: false,
        data: null,
        errorMsg: error && error.message ? error.message : "Unexpected error",
      });
    }

    return;
  };

  const togglePasswordVisibility = () => setPasswordVisible((prev) => !prev);

  const openSuccessModal = () =>
    setSuccessModal({ visible: true, onHide: hideSuccessModal, size: "md" });

  const hideSuccessModal = () =>
    setSuccessModal({ visible: false, onHide: null, size: "md" });

  const displayCarouselItems = carouselItems.map((item, i) => {
    const { img, caption } = item;

    return (
      <div key={i} className="flex flex-col items-center justify-center py-20">
        <div className="w-full max-w-3xl flex items-center justify-center mb-12">
          <img src={img} className="w-full" alt="" />
        </div>

        <p className="text-lg text-[#F7FAFF] font-normal leading-[30px] m-0 p-0 font-poppins text-center">
          {caption}
        </p>
      </div>
    );
  });

  return (
    <div className="min-h-screen bg-[#130828]">
      <ScrollTo condition={apiReqs.errorMsg}>
        <div className=" py-4 px-3 md:px-5 lg:px-5 h-full">
          {/* <div className="flex flex-col items-start">
            <div className="flex flex-col items-center justify-center">
              <div className="mb-0 w-full lg:w-8/12 flex items-center justify-center">
                <img src={logo} className="w-full" alt="" />
              </div>
            </div>
          </div> */}

          <div className="flex flex-col md:flex-row lg:flex-row justify-between items-center">
            <div className="w-full text-center mt-20 lg:w-5/12">
              <h1 className="text-white  text-2xl font-medium mb-4 font-quantico">
                <span className="bg-gradient-to-r from-[#BD3193] to-[#9FCB3A] text-transparent bg-clip-text">
                  Welcome Gamer
                </span>
              </h1>

              <p className="text-white text-sm opacity-70 font-poppins font-light mb-4">
                We're glad to see you again
              </p>

              <div className="flex items-center justify-between">
                <div className="w-1/2 pr-2">
                  <div className="w-full p-2 flex items-center justify-center cursor-pointer bg-login-option">
                    <div className="px-1">
                      <CustomSvg name="google" />
                    </div>
                    <p className="text-white text-sm font-inter font-normal leading-tight m-0 p-0">
                      Sign in with Google
                    </p>
                  </div>
                </div>
                <div className="w-1/2 pl-2 flex items-center justify-end">
                  <div className="w-full p-2 flex items-center justify-center cursor-pointer bg-login-option">
                    <div className="px-1">
                      <CustomSvg name="apple" />
                    </div>
                    <p className="px-1 text-white text-sm font-inter font-normal leading-snug m-0 p-0">
                      Sign in with Apple
                    </p>
                  </div>
                </div>
              </div>

              <div className=" py-5 flex items-center justify-between">
                <div className="w-5/12 border-t border-white opacity-20"></div>
                <p className="text-white text-sm font-poppins font-light opacity-70 m-0 p-0">
                  Or
                </p>
                <div className="w-5/12 border-t border-white opacity-20"></div>
              </div>

              {apiReqs.errorMsg && (
                <CustomErrorMsg
                  errorMsg={apiReqs.errorMsg}
                  verticalPadding={true}
                />
              )}

              <Formik
                validationSchema={validationSchema}
                initialValues={{ email: "", password: "" }}
                onSubmit={(values) => {
                  setApiReqs({
                    isLoading: true,
                    data: values,
                    errorMsg: null,
                  });
                }}
              >
                {({
                  values,
                  dirty,
                  isValid,
                  handleBlur,
                  handleChange,
                  handleSubmit,
                }) => (
                  <div className="mb-3 w-full">
                    <div>
                      <div className="mb-4">
                        <div className="flex items-center bg-register-input p-2">
                          <div className="w-[3%]">
                            <CustomSvg name="mail" />
                          </div>
                          <input
                            name="email"
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.email}
                            placeholder="Enter your email address"
                            className="w-[94%] text-white mx-4 text-base font-quantico bg-transparent outline-none"
                          />
                        </div>
                        <ErrorMessage
                          name="email"
                          render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                        />
                      </div>
                      <div className="mb-4">
                        <div className="flex items-center bg-register-input p-2">
                          <div className="w-[3%]">
                            <CustomSvg name="lock" />
                          </div>
                          <input
                            name="password"
                            type={passwordVisible ? "text" : "password"}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            value={values.password}
                            placeholder="Enter your password"
                            className="w-[88%] text-white mx-4 text-base font-quantico bg-transparent outline-none"
                          />
                          <div
                            className="cursor-pointer"
                            onClick={togglePasswordVisibility}
                          >
                            {passwordVisible ? (
                          <FiEye color="#fff" />
                            ) : (
                                    <FiEyeOff color="#fff" />
                            
                            )}
                          </div>
                        </div>
                        <ErrorMessage
                          name="password"
                          render={(msg) => <CustomErrorMsg errorMsg={msg} />}
                        />
                      </div>
                    </div>

                    <div className="flex justify-between mb-5">
                      <div className="flex items-center">
                        <input type="checkbox" />
                        <p className="text-white text-sm font-poppins font-normal ml-2">
                          Remember me
                        </p>
                      </div>
                      <p
                        onClick={goToForgotPassword}
                        className="text-pink-600 text-sm font-poppins font-light cursor-pointer"
                      >
                        Forgot Password?
                      </p>
                    </div>

                    <div className="w-full mb-3">
                      <button
                        type="submit"
                        onClick={handleSubmit}
                        disabled={!(isValid && dirty) || apiReqs.isLoading}
                        className="w-full bg-pink-600 text-white flex items-center justify-center p-2 cursor-pointer disabled:opacity-50"
                      >
                        {apiReqs.isLoading ? (
                          <div className="py-1">
                            <Spinner size="sm" variant="light" />
                          </div>
                        ) : (
                          <>
                            <p className="text-sm font-poppins font-medium mx-1">
                              Login
                            </p>
                            <div className="mx-2 flex items-center">
                              <CustomSvg name="arrow-right" />
                            </div>
                          </>
                        )}
                      </button>
                    </div>
                  </div>
                )}
              </Formik>

              <div className="flex items-center justify-center">
                <p
                  onClick={goToRegister}
                  className="text-white text-sm font-poppins font-normal cursor-pointer"
                >
                  Don't have an account?{" "}
                  <span className="text-pink-600 opacity-70">Register</span>.
                </p>
              </div>
            </div>

            <div className="hidden md:hidden lg:flex w-6/12 items-center justify-center">
              <div className="w-10/12 bg-carousel px-4 py-5">
                <Carousel controls={false}>{displayCarouselItems}</Carousel>
              </div>
            </div>
          </div>
        </div>
      </ScrollTo>

      <SuccessModal
        modalProps={successModal}
        redirectFunc={goToDashboard}
        subTxt="Successfully logged in, we are redirecting you..."
        accountType={accountType}
        className="bg-none border-0"
      />
    </div>
  );
}
